module.exports = __webpack_public_path__ + "img/spritesheet.fd5728f2.svg";